import { createRestClient } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks/useGetSearchParams'
import { DataGridComponent } from '@/ui/DataGrid/DataGridComponent'
import { ErrorComponent } from '@/ui/ErrorComponent'
import { Loading } from '@/ui/Loading'
import { appTableColumns } from './appTableColumns'
import { useState } from 'react'
import { AddApplicationForm } from '@/ui/Forms/AddApplicationForm'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'

export function ApplicationsTable() {
  const [addAppDrawerOpen, setAddAppDrawerOpen] = useState<boolean>(false)

  const { getApplicationsApiGetApplications } = createRestClient()
  const appId = useGetSearchParam<number>('appId')
  const tab = useGetSearchParam<string>('tab')
  const { data: applications, isPending, isError } = getApplicationsApiGetApplications.useQuery()

  if (appId || tab) {
    return null
  }

  if (isPending) return <Loading />
  if (isError) return <ErrorComponent />
  return (
    <>
      <DataGridComponent items={applications} columns={appTableColumns} onAdd={() => setAddAppDrawerOpen(true)} />

      <OverlayDrawerComponent
        key="addform"
        open={addAppDrawerOpen}
        setOpen={setAddAppDrawerOpen}
        title="Add application"
        content={
          <AddApplicationForm
            onSubmit={() => {
              setAddAppDrawerOpen(false)
              // fetchApplicationsList()
            }}
          />
        }
      />
    </>
  )
}
